<div class="chat-app" [class.is-pane-open]="paneOpen">
  <aside
    class="chat-app__rail"
    chatAppRailResize
    #rail="chatAppRailResize"
    [attr.aria-label]="'chatApp.shell.conversations' | translate"
  >
    <!-- Collapsed rail: photos only — what needs room is one drag (or Enter / a double click on the handle) away. -->
    <header
      class="chat-app__rail-header d-flex align-items-center gap-2"
      [class.justify-content-between]="!rail.collapsed"
      [class.justify-content-center]="rail.collapsed"
    >
      <div class="d-flex align-items-center gap-2 overflow-hidden">
        <button
          type="button"
          class="chat-app__me chat-avatar-tile flex-shrink-0"
          (click)="openStatusPicker()"
          [attr.aria-label]="'chat.status.open' | translate"
        >
          @if (currentUser?.image) {
            <img [src]="$safeNavigationMigration(currentUser?.image)" alt="" aria-hidden="true" (error)="onImageError($event)" />
          } @else {
            {{ resolveInitials($safeNavigationMigration(currentUser?.name)) }}
          }
          <span class="chat-avatar-tile__presence rounded-circle" [ngClass]="myPresence.dotClass" aria-hidden="true"></span>
        </button>
        @if (!rail.collapsed) {
          <chat-status-button class="d-block overflow-hidden"></chat-status-button>
        }
      </div>

      <!-- Creating conversations lives on the "Canais" / "Mensagens diretas" section headers. -->
      @if (!rail.collapsed) {
        <div class="dropdown flex-shrink-0">
          <button
            type="button"
            class="chat-app__icon-action dropdown-toggle arrow-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            [attr.aria-label]="'chatApp.shell.menu' | translate"
          >
            <i class="ri-more-2-fill" aria-hidden="true"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <a href="javascript:void(0);" class="dropdown-item" (click)="openPreferences()">
              <i class="ri-notification-3-line me-1" aria-hidden="true"></i>{{ 'chat.shell.preferences' | translate }}
            </a>
            @if (installMode !== 'none') {
              <a href="javascript:void(0);" class="dropdown-item" (click)="install()">
                <i class="ri-install-line me-1" aria-hidden="true"></i>{{ 'chatApp.install.menuEntry' | translate }}
              </a>
            }
            <a class="dropdown-item" [href]="productUrl" target="trendmulti-app" rel="noopener">
              <i class="ri-external-link-line me-1" aria-hidden="true"></i>{{ 'chatApp.common.openProduct' | translate }}
            </a>
            <div class="dropdown-divider"></div>
            <a href="javascript:void(0);" class="dropdown-item text-danger" (click)="signOut()">
              <i class="ri-logout-box-r-line me-1" aria-hidden="true"></i>{{ 'chatApp.common.signOut' | translate }}
            </a>
          </div>
        </div>
      }
    </header>

    @if (showNotificationCta && !rail.collapsed) {
      <div class="chat-app__rail-card" role="region" [attr.aria-label]="'chatApp.notifications.title' | translate">
        <div class="d-flex align-items-start gap-2">
          <i class="ri-notification-badge-line font-20 flex-shrink-0" aria-hidden="true"></i>
          <div class="flex-grow-1">
            <p class="fw-semibold mb-1">{{ 'chatApp.notifications.title' | translate }}</p>
            <p class="chat-app__rail-card-text mb-2">{{ 'chatApp.notifications.body' | translate }}</p>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm btn-primary" (click)="enableNotifications()">
                {{ 'chatApp.notifications.enable' | translate }}
              </button>
              <button type="button" class="btn btn-sm btn-light" (click)="dismissNotificationCta()">
                {{ 'chatApp.common.notNow' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showInstallCard && !rail.collapsed) {
      <div class="chat-app__rail-card" role="region" [attr.aria-label]="'chatApp.install.title' | translate">
        <div class="d-flex align-items-start gap-2">
          <i class="ri-smartphone-line font-20 flex-shrink-0" aria-hidden="true"></i>
          <div class="flex-grow-1">
            <p class="fw-semibold mb-1">{{ 'chatApp.install.title' | translate }}</p>
            <p class="chat-app__rail-card-text mb-2">{{ 'chatApp.install.body' | translate }}</p>
            <div class="d-flex gap-2">
              <button type="button" class="btn btn-sm btn-primary" (click)="install()">
                {{ 'chatApp.install.action' | translate }}
              </button>
              <button type="button" class="btn btn-sm btn-light" (click)="dismissInstall()">
                {{ 'chatApp.common.dismiss' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (chatUnavailable$ | async) {
      <div class="chat-app__rail-state">
        <chat-unavailable [compact]="true" (retry)="retryBootstrap()"></chat-unavailable>
      </div>
    } @else if (bootstrapFailed$ | async) {
      <div class="chat-app__rail-state">
        <chat-error-state [compact]="true" (retry)="retryBootstrap()"></chat-error-state>
      </div>
    } @else {
      <!-- One highlight at a time: a pane on screen takes it from the last conversation. -->
      <chat-conversation-list
        variant="rail"
        [collapsed]="rail.collapsed"
        [activePane]="activePane"
        [activeChannelId]="activePane ? null : activeChannelId"
        (conversationSelected)="openConversation($event)"
        (messageHitSelected)="openMessage($event)"
        (paneSelected)="openPane($event)"
      ></chat-conversation-list>
    }

    <footer
      class="chat-app__rail-footer d-flex align-items-center"
      [class.justify-content-end]="!rail.collapsed"
      [class.justify-content-center]="rail.collapsed"
    >
      <button
        type="button"
        class="chat-app__icon-action"
        (click)="toggleTheme()"
        [matTooltip]="(isDarkTheme ? 'chatApp.shell.themeLight' : 'chatApp.shell.themeDark') | translate"
        [attr.aria-label]="(isDarkTheme ? 'chatApp.shell.themeLight' : 'chatApp.shell.themeDark') | translate"
      >
        <i [ngClass]="isDarkTheme ? 'ri-sun-line' : 'ri-moon-line'" aria-hidden="true"></i>
      </button>
    </footer>

    <!-- Resize handle (desktop only): drag, the arrow keys, and Enter or a double click to collapse/restore. -->
    <div
      class="chat-app__rail-resizer"
      role="separator"
      tabindex="0"
      aria-orientation="vertical"
      [attr.aria-label]="'chatApp.shell.resizeRail' | translate"
      [attr.aria-valuenow]="rail.widthPx"
      [attr.aria-valuemin]="rail.minPx"
      [attr.aria-valuemax]="rail.maxPx"
      (pointerdown)="rail.onPointerDown($event)"
      (pointerup)="rail.onPointerRelease()"
      (pointercancel)="rail.onPointerRelease()"
      (lostpointercapture)="rail.onPointerRelease()"
      (keydown)="rail.onKeydown($event)"
      (dblclick)="rail.onDoubleClick()"
    ></div>
  </aside>

  <section class="chat-app__pane">
    @if (updateService.unrecoverable$ | async) {
      <div class="alert alert-danger rounded-0 mb-0 d-flex align-items-center gap-2" role="alert">
        <p class="mb-0 flex-grow-1"><i class="ri-error-warning-line me-1" aria-hidden="true"></i>{{ 'chatApp.update.unrecoverable' | translate }}</p>
        <button type="button" class="btn btn-sm btn-danger" (click)="updateService.reload()">{{ 'chatApp.update.reload' | translate }}</button>
      </div>
    } @else if (updateService.updateReady$ | async) {
      <div class="alert alert-info rounded-0 mb-0 d-flex align-items-center gap-2" role="status">
        <p class="mb-0 flex-grow-1"><i class="ri-refresh-line me-1" aria-hidden="true"></i>{{ 'chatApp.update.available' | translate }}</p>
        <button type="button" class="btn btn-sm btn-info" (click)="updateService.reload()">{{ 'chatApp.update.reload' | translate }}</button>
      </div>
    }
    <chat-connection-banner></chat-connection-banner>
    <div class="chat-app__outlet">
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
